
import Vue, { PropType } from "vue";
import { mapActions } from "vuex";
import Place from "~/entities/Place";

export default Vue.extend({
  props: {
    validated: Boolean,
    label: {
      type: String,
      default: "",
    },
    googleObj: {
      type: Function as PropType<(element:HTMLElement, element2:any) => void>,
      default: null,
    },
    preSelection: {
      type: String,
      default: "",
    },
    errors: {
      type: Boolean,
      default: false,
    },
    equal: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "location",
    },
  },
  data() {
    return {
      autocomplete: {} as google.maps.places.Autocomplete,
      location: null as null | string,
      place: {} as Place,
      processing: false,
      autocompleteOptions: {} as any,
    };
  },
  computed: {
    placeholder(): string {
      return this.label;
    },
  },
  watch: {
    // This will ideally happen just once, after initMap
    googleObj(): void {
      if (typeof this.googleObj === 'function') this.setupGoogle();
    },
    errors(newVal): void {
      if (newVal) {
        (this.$refs.input as HTMLElement).focus();
      }
    },
  },
  mounted() {
    this.setupGoogle();
    if (this.preSelection) {
      this.location = this.preSelection;
    }
  },
  methods: {
    ...mapActions({
      requestResolve: "ship/requestResolve",
    }),
    setupGoogle(): void {
      if (!this.googleObj) return;
      this.autocompleteOptions = {
        fields: [
          "formatted_address",
          "geometry",
          "name",
          "address_components",
          "vicinity",
          "type",
        ],
        strictBounds: false,
      };
      const Google = this.googleObj;
      this.autocomplete = new Google(
        this.$refs.input as HTMLElement,
        this.autocompleteOptions
      );
      this.autocomplete.addListener("place_changed", () => {
        this.onClickLocation();
      });
      const inputElement = document.getElementById(this.id);
      if (inputElement) {
        const event = new Event("focus");
        inputElement.dispatchEvent(event);
        google.maps.event.trigger((this as any).$refs.input, "focus", {
          handle: this.$refs.input,
        });
        google.maps.event.trigger((this as any).$refs.input, "keydown", {
          key: "Enter",
          keyCode: 13,
          triggered: true,
        });
        inputElement.addEventListener("keydown", (event: object) => {
          this.onClickTaB(event);
        });
        inputElement.addEventListener("paste", (event: object) => {
          this.select();
        });
      }
    },
    onClickTaB(event): void {
      if (event.keyCode === 9) {
        (this as any).select();
      }
    },
    onClickLocation(): void {
      this.processing = false;
      setTimeout(() => {
        this.place = new Place(this.autocomplete.getPlace());
        this.location = this.place
          ? (this.place.formatted_address as string)
          : this.location;
        this.ResolveLocation();
      }, 200);
    },
    async ResolveLocation(): Promise<void> {
      try {
        const resolvedLocation = await (this as any).requestResolve({
          address: this.place.address_components,
          originalAddress: this.place.formatted_address,
          company: this.place.name,
          type: 1,
        });
        if (resolvedLocation && !resolvedLocation.forLocation) {
          const result =
            this.place.reverseResolvedAddressComponents(resolvedLocation);
          if (result && result.changes) {
            this.$emit("emitUserDetails", result.detail);
            if (this.place && this.location !== this.place.formatted_address) {
              this.location = this.place
                ? (this.place.formatted_address as string)
                : this.location;
            }
          }
        } else if (resolvedLocation && resolvedLocation.forLocation) {
          this.$emit("emitUserDetails", false);
          const result =
            this.place.reverseResolvedLocationComponents(resolvedLocation);
          if (result)
            this.location = this.place
              ? (this.place.formatted_address as string)
              : this.location;
        } else {
          this.place.formatLabel(false, resolvedLocation);
          this.$emit("emitUserDetails", false);
        }
        this.$emit("emitLocation", this.place);
        this.processing = true;
      } catch (e) {
        this.processing = true;
      }
    },
    async select() {
      if (!this.$refs.input) return;
      const _this = this;
      try {
        setTimeout(function () {
          google.maps.event.trigger((_this as any).$refs.input, "focus", {
            handle: (_this as any).$refs.input,
          });
        }, 50);
        setTimeout(function () {
          try {
            google.maps.event.trigger((_this as any).$refs.input, "keydown", {
              key: "ArrowDown",
              keyCode: 40,
            });
          } catch (e) {}
        }, 750);
        setTimeout(function () {
          google.maps.event.trigger((_this as any).$refs.input, "keydown", {
            key: "Enter",
            keyCode: 13,
            triggered: true,
          });
        }, 1000);
      } catch (error) {}
    },
  },
});
